import React, { useState } from 'react';
import './SecureDownload.css';

function SecureDownload() {
  const [password, setPassword] = useState('');
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleUnlock = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setIsSubmitting(true);

    try {
      const response = await fetch('/api/secure-auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });

      if (!response.ok) {
        let serverMessage = '';
        try {
          const payload = await response.json();
          serverMessage = payload?.error || '';
        } catch (parseError) {
          serverMessage = '';
        }

        if (response.status === 401) {
          setError(serverMessage || 'Incorrect password. Please try again.');
        } else {
          setError(serverMessage || 'Unable to verify password right now. Please try again.');
        }

        setIsUnlocked(false);
        return;
      }

      setIsUnlocked(true);
      setPassword('');
      setMessage('Access granted. Your PDF is ready to open.');
    } catch (requestError) {
      setError('Unable to verify password right now. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenPdf = () => {
    setError('');
    setMessage('');

    const openedWindow = window.open('/api/secure-download', '_blank', 'noopener,noreferrer');
    if (!openedWindow) {
      setError('Popup blocked. Please allow popups for this site and try again.');
      return;
    }

    setMessage('Opened PDF in a new tab.');
  };

  const handleLogout = async () => {
    setIsUnlocked(false);
    setPassword('');
    setMessage('');
    setError('');
    await fetch('/api/secure-auth', { method: 'DELETE' });
  };

  return (
    <main className="secure-download-page">
      <section className="secure-download-card">
        <h1>Secure Document Access</h1>
        <p>Enter your password to unlock the PDF download.</p>

        {!isUnlocked ? (
          <form onSubmit={handleUnlock} className="secure-download-form">
            <label htmlFor="securePassword">Password</label>
            <input
              id="securePassword"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              autoComplete="current-password"
            />
            <button type="submit" disabled={isSubmitting} className="unlock-button">
              {isSubmitting ? 'Verifying...' : 'Unlock Download'}
            </button>
          </form>
        ) : (
          <div className="secure-download-actions">
            <button type="button" onClick={handleOpenPdf}>
              Open PDF
            </button>
            <button type="button" className="secondary" onClick={handleLogout}>
              Lock Page
            </button>
          </div>
        )}

        {error && <p className="secure-message error">{error}</p>}
        {message && <p className="secure-message success">{message}</p>}
      </section>
    </main>
  );
}

export default SecureDownload;
